export default __webpack_public_path__ + "static/gitkraken_loading-8b653b705abb21a541b2dfb8b9d2508c.gif";